export default __webpack_public_path__ + "static/media/twitter.77365f90.png";